export const FETCH_PROFILE_REQUEST = '@profile/FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS = '@profile/FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = '@profile/FETCH_PROFILE_FAILURE';
export const CLEAR_PROFILE = '@profile/CLEAR_PROFILE';
